
import React from 'react';
import { FaRobot } from 'react-icons/fa6';

export const MotiveIntegrationTab = ({ setActiveTab, activeTab }) => {
  return (
    <>
      <li className="nav-item">
        <button
          className={`nav-link ${activeTab === 'motiveIntegration' ? 'active' : ''}`}
          onClick={() => setActiveTab('motiveIntegration')}
        >
         <span style={{ marginRight: '5px', fontSize: '20px' }}><FaRobot /></span>
          Motive Integration
        </button>
      </li>
    </>
  );
};